import { put, takeLatest, fork, call } from "redux-saga/effects";
import { httpStatus } from "configs/httpStatus";
import { autoReleaseContract } from "services/contractInformation";
import { handleSuccesAction, handleErrorAction } from "./autoReleaseActions";
import {
  IAutoReleasePayload,
  IAutoReleaseResponse,
  ActionType,
} from "models/contract/autoRelease";

function* autoReleaseSaga({ payload }: { payload: IAutoReleasePayload }) {
  try {
    const response: IAutoReleaseResponse = yield call(
      autoReleaseContract,
      payload
    );
    if (
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusOK
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}

function* onAutoReleaseWatcher() {
  yield takeLatest(
    ActionType.CONTRACT_INFORMATION_AUTO_RELEASE as any,
    autoReleaseSaga
  );
}

export default [fork(onAutoReleaseWatcher)];
